var map = {
	"./Barbarian.png": "5e83",
	"./Bard.png": "2ac8",
	"./Cleric.png": "663d",
	"./Druid.png": "7058",
	"./Monk.png": "38ee",
	"./Paladin.png": "04df",
	"./Ranger.png": "1844",
	"./Rogue.png": "19ad",
	"./Wizard.png": "edf8",
	"./female/Barbarian.png": "fa34",
	"./female/Bard.png": "704f",
	"./female/Cleric.png": "e2af",
	"./female/Druid.png": "3d3e",
	"./female/Monk.png": "55ea",
	"./female/Paladin.png": "b905",
	"./female/Ranger.png": "d927",
	"./female/Rogue.png": "99b2",
	"./female/Wizard.png": "7c72",
	"./full/female/barbarian.png": "9032",
	"./full/female/bard.png": "68ff",
	"./full/female/cleric.png": "83f7",
	"./full/female/druid.png": "4e11",
	"./full/female/monk.png": "f2e9",
	"./full/female/paladin.png": "2085",
	"./full/female/ranger.png": "9d0f",
	"./full/female/rogue.png": "756a",
	"./full/female/wizard.png": "2ef4",
	"./full/male/barbarian.png": "9374",
	"./full/male/bard.png": "b5d2",
	"./full/male/cleric.png": "e14c",
	"./full/male/druid.png": "ed05",
	"./full/male/monk.png": "7af1",
	"./full/male/paladin.png": "c535",
	"./full/male/ranger.png": "3e90",
	"./full/male/rogue.png": "2436",
	"./full/male/wizard.png": "b7d5",
	"./male/Barbarian.png": "5ffa",
	"./male/Bard.png": "7c25",
	"./male/Cleric.png": "6c58",
	"./male/Druid.png": "0f45",
	"./male/Monk.png": "205c",
	"./male/Paladin.png": "77dc",
	"./male/Ranger.png": "177b",
	"./male/Rogue.png": "90e8",
	"./male/Wizard.png": "24ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c388";